import Vue from 'vue';
import VueRouter from 'vue-router';
import Admin from '@/pages/Admin';
import AdminUser from '@/pages/Admin/User';
import AdminRole from '@/pages/Admin/User/Role';
import AdminMenu from '@/pages/Admin/User/Menu';
import AdminCustom from '@/pages/Admin/User/Custom';
import AdminUserInfo from '@/pages/Admin/User/Info';
import AdminGoods from '@/pages/Admin/Goods';
import AdminGoodsDetail from '@/pages/Admin/Goods/Detail';
import AdminGoodsType from '@/pages/Admin/Goods/Type';
import AdminGoodsBrand from '@/pages/Admin/Goods/Brand';
import AdminGoodsAdd from '@/pages/Admin/Goods/add.vue';
import AdminLog from '@/pages/Admin/Log';
import Shop from '@/pages/Admin/Shop';
import BaoJia from '@/pages/Admin/BaoJia';
import ComInfo from '@/pages/Admin/ComInfo';
import CusInfo from '@/pages/Admin/CusInfo';
import Ceshi from '@/pages/Admin/Ceshi';
import GoodsOrder from '@/pages/Admin/Goods/Order';
import AdminList from '@/pages/Admin/List';
import AdminPic from '@/pages/Admin/Pic';
import AdminBanma from '@/pages/Admin/Banma';
import AdminTimeline from '@/pages/Admin/Goods/TimeLine';
import AdminProduct from '@/pages/Admin/Project';
import AdminProductType from '@/pages/Admin/ProductType';
import AdminShop2 from '@/pages/Admin/Shop2';
import AdminShopOrder from '@/pages/Admin/ShopOrder';
import AdminHome from '@/pages/Admin/Home';
import CusDetail from '@/pages/Admin/CusDetail';
import CusAdd from '@/pages/Admin/CusAdd';

Vue.use(VueRouter);
export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            name: '首页',
            path: '/',
            component: Admin,
            redirect: '/admin/home',
            meta: {
                metaInfo: {
                    title: '客户信息管理系统-后台首页',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '后台首页',
            path: '/admin',
            component: Admin,
            redirect: '/admin/home',
            meta: {
                metaInfo: {
                    title: '客户信息管理系统-后台首页',
                    keywords: '',
                    description: ''
                }
            },
            children: [
                {
                    name: '数据面板',
                    path: 'home',
                    component: AdminHome,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-数据面板',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '员工管理',
                    path: 'user',
                    component: AdminUser,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-员工管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '个人信息',
                    path: 'info',
                    component: AdminUserInfo,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-个人信息',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '角色管理',
                    path: 'role',
                    component: AdminRole,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-角色管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '客户管理',
                    path: 'custom',
                    component: AdminCustom,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-客户管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '菜单管理',
                    path: 'menu',
                    component: AdminMenu,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-菜单管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '商品管理',
                    path: 'goods',
                    component: AdminGoods,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-商品管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '分类管理',
                    path: 'goodstype',
                    component: AdminGoodsType,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-分类管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '品牌管理',
                    path: 'goodsbrand',
                    component: AdminGoodsBrand,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-品牌管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '添加商品',
                    path: 'goodsadd',
                    component: AdminGoodsAdd,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-添加商品',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '操作日志',
                    path: 'log',
                    component: AdminLog,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-操作日志',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '采购中心',
                    path: 'shop',
                    component: Shop,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-采购中心',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '报价单生成',
                    path: 'baojia',
                    component: BaoJia,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-报价单生成',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '报价信息生成',
                    path: 'cominfo',
                    component: ComInfo,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-报价信息生成',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '询价信息生成',
                    path: 'cusinfo',
                    component: CusInfo,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-询价信息生成',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '订单管理',
                    path: 'order',
                    component: GoodsOrder,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-订单管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '销售榜单',
                    path: 'list/:year/:month',
                    component: AdminList,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-销售榜单',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '添加标记',
                    path: 'pic',
                    component: AdminPic,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-添加标记',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '标记查询',
                    path: 'banma/:id',
                    component: AdminBanma,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-标记查询',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '订单详情',
                    path: 'timeline/:id',
                    component: AdminTimeline,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-商品时间线',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '商品项目管理',
                    path: 'product',
                    component: AdminProduct,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-商品项目管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '商品项目类型管理',
                    path: 'producttype',
                    component: AdminProductType,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-商品项目类型管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '产品商城',
                    path: 'shop2',
                    component: AdminShop2,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-产品商城',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '产品订单管理',
                    path: 'shoporder',
                    component: AdminShopOrder,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-产品订单管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '客户详情',
                    path: 'cusdetail/:id',
                    component: CusDetail,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-客户详情',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '添加客户',
                    path: 'cusadd',
                    component: CusAdd,
                    meta: {
                        metaInfo: {
                            title: '客户信息管理系统-添加客户',
                            keywords: '',
                            description: ''
                        }
                    }
                },
            ]
        },
        {
            name: 'ceshi',
            path: '/ceshi',
            component: Ceshi,
            meta: {
                metaInfo: {
                    title: '客户信息管理系统-ceshi',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '商品详情',
            path: '/detail/:id',
            component: AdminGoodsDetail,
            meta: {
                metaInfo: {
                    title: '客户信息管理系统-商品管理',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});